import Cookies from "js-cookie"
import { create } from "zustand"

import type { VariationProductData } from "@/lib/storefront/product/product"

interface UbPDPState {
  selectedFilterOptions: Record<string, string | undefined>
  useClientSelectedFilterOptions: boolean
  filterClicked: boolean
  variantSortAsc: boolean
  variantIndexes: Record<string, VariationProductData[]>
  setFilterClicked: (filterClicked: boolean) => void
  setVariantSortAsc: (variantSortAsc: boolean) => void
  setVariantIndex: (masterProductId: string, variants: VariationProductData[]) => void

  setUseClientSelectedFilterOptions: (useClientSelectedFilterOptions: boolean) => void

  selectOptionForAttribute: (id: string, value: string) => void
  setSelectedFilterOptions: (selectedFilterOptions: Record<string, string | undefined> | undefined) => void

  buyboxQuantity: number
  setBuyboxQuantity: (quantity: number) => void
}

export const useUbPDPState = create<UbPDPState>((set) => ({
  selectedFilterOptions: Cookies.get("selectedFilterOptions") ?? {},
  setSelectedFilterOptions: (selectedFilterOptions: Record<string, string | undefined> | undefined) =>
    set(() => ({ selectedFilterOptions: selectedFilterOptions ?? {} })),

  useClientSelectedFilterOptions: false,
  filterClicked: false,
  variantSortAsc: true,
  variantIndexes: {},

  setVariantSortAsc: (variantSortAsc: boolean) => set(() => ({ variantSortAsc: variantSortAsc })),
  setVariantIndex: (masterProductId: string, variants: VariationProductData[]) =>
    set((state) => ({
      variantIndexes: {
        ...state.variantIndexes,
        [masterProductId]: variants,
      },
    })),

  setFilterClicked: (filterClicked: boolean) => {
    //console.log("setFilterClicked", filterClicked)
    return set(() => ({ filterClicked: filterClicked }))
  },

  setUseClientSelectedFilterOptions: (useClientSelectedFilterOptions: boolean) =>
    set(() => ({ useClientSelectedFilterOptions: useClientSelectedFilterOptions })),

  selectOptionForAttribute: (id: string, value: string) =>
    set((state) => ({
      ...state,
      selectedFilterOptions: { ...state.selectedFilterOptions, [id]: value },
      useClientSelectedFilterOptions: true,
    })),

  buyboxQuantity: 1,
  setBuyboxQuantity: (quantity: number) => set(() => ({ buyboxQuantity: quantity })),
}))
